<div
  class="agent-tool-call"
  [class.agent-tool-call--running]="status() === 'running'"
  [class.agent-tool-call--done]="status() === 'done'"
  [class.agent-tool-call--error]="status() === 'error'">
  <button type="button" class="agent-tool-call__header" (click)="toggle()" [attr.aria-expanded]="expanded()">
    <mat-icon class="agent-tool-call__status-icon" [class.agent-tool-call__status-icon--spin]="status() === 'running'">
      {{ statusIcon() }}
    </mat-icon>
    <span class="agent-tool-call__name">{{ displayName() | translate }}</span>
    <mat-icon class="agent-tool-call__chevron">{{ expanded() ? "expand_less" : "expand_more" }}</mat-icon>
  </button>

  @if (status() === "error") {
    <div class="agent-tool-call__error">{{ errorKey() | translate }}</div>
  } @else if (status() === "skipped") {
    <div class="agent-tool-call__skipped">{{ "agent.tool-skipped" | translate }}</div>
  }

  @if (expanded()) {
    <div class="agent-tool-call__detail">
      @if (inputView(); as view) {
        <div class="agent-tool-call__section-label">{{ "agent.tool.request" | translate }}</div>
        <app-agent-tool-result [view]="view"></app-agent-tool-result>
      } @else if (inputJson()) {
        <div class="agent-tool-call__section-label">{{ "agent.tool.request" | translate }}</div>
        <pre class="agent-tool-call__json">{{ inputJson() }}</pre>
      }

      @if (resultView(); as view) {
        <div class="agent-tool-call__section-label">{{ "agent.tool.result" | translate }}</div>
        <app-agent-tool-result [view]="view"></app-agent-tool-result>
      } @else if (resultJson()) {
        <div class="agent-tool-call__section-label">{{ "agent.tool.result" | translate }}</div>
        <pre class="agent-tool-call__json">{{ resultJson() }}</pre>
      }

      @if (canShowRaw()) {
        <button type="button" class="agent-tool-call__raw-toggle" (click)="toggleRaw()">
          {{ (showRaw() ? "agent.tool.hide-raw" : "agent.tool.show-raw") | translate }}
        </button>
        @if (showRaw()) {
          @if (inputView() && inputJson()) {
            <pre class="agent-tool-call__json">{{ inputJson() }}</pre>
          }
          @if (resultView() && resultJson()) {
            <pre class="agent-tool-call__json">{{ resultJson() }}</pre>
          }
        }
      }
    </div>
  }
</div>
